{
  "v": "5.9.0",
  "fr": 25,
  "ip": 0,
  "op": 89,
  "w": 1000,
  "h": 1000,
  "nm": "Stay",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "bed base Outlines",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [500, 526, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [35, 27, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [1000, 1000, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [1.633, 0.123],
                    [2.253, 0],
                    [0.849, -0.242],
                    [0, -1.122],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.685, 0.105],
                    [2.092, 0],
                    [0.378, -0.125],
                    [0, -1.06],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-2.171, 0],
                    [0, 0],
                    [0, 0],
                    [0, -1.956],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, -2.103],
                    [-0.904, -0.068],
                    [-3.147, 0],
                    [-1.119, 0.319],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, -2.293],
                    [-0.973, -0.061],
                    [-4.556, 0],
                    [-1.087, 0.358],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, -2.083],
                    [0, 0],
                    [0, 0],
                    [2.057, 0.122],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [20.07, 8.917],
                    [20.07, 3.658],
                    [16.021, 0.27],
                    [10.864, 0.13],
                    [4.576, 0.51],
                    [2.133, 3.658],
                    [2.133, 8.197],
                    [-2.133, 8.197],
                    [-2.133, 3.658],
                    [-6.326, 0.27],
                    [-11.39, 0.143],
                    [-17.696, 0.559],
                    [-20.07, 3.658],
                    [-20.07, 8.917],
                    [-26.199, 9.12],
                    [-26.199, -4.572],
                    [-21.458, -9.12],
                    [-21.345, -9.118],
                    [21.696, -9.111],
                    [26.199, -4.572],
                    [26.199, 9.12]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [34.989, 11.544], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 1.133],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.991, 0],
                    [0, 0],
                    [0, 1.086],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.943, -0.036]
                  ],
                  "o": [
                    [-0.99, -0.002],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 1.136],
                    [0, 0],
                    [-0.939, -0.036],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 1.086],
                    [0, 0]
                  ],
                  "v": [
                    [29.999, 6.878],
                    [27.368, 4.676],
                    [27.368, 2.85],
                    [-27.368, 2.85],
                    [-27.368, 4.676],
                    [-30.001, 6.878],
                    [-30.065, 6.877],
                    [-32.565, 4.676],
                    [-32.565, -6.878],
                    [32.566, -6.878],
                    [32.566, 4.676],
                    [30.059, 6.877]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [34.989, 44.27], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [-2.629, 0.568],
                    [0, 0],
                    [-8.41, 0],
                    [-3.887, -0.015],
                    [0, 0],
                    [-3.913, 0],
                    [-2.471, 0.018],
                    [0, -3.053],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, -2.529],
                    [0, 0],
                    [6.15, -0.155],
                    [3.953, 0],
                    [0, 0],
                    [3.853, 0.015],
                    [2.929, 0],
                    [3.137, 0.084],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-32.565, 7.034],
                    [-32.565, -0.287],
                    [-27.049, -6.783],
                    [-26.935, -6.807],
                    [-5.893, -7.034],
                    [5.967, -7.003],
                    [6.072, -7.002],
                    [17.82, -6.971],
                    [25.845, -6.998],
                    [32.565, -0.287],
                    [32.565, 7.034]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [34.989, 29.049], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -2.68],
                    [0, 0],
                    [0, 0],
                    [0, -2.871],
                    [0, 0],
                    [-1.401, -0.053],
                    [0, 0],
                    [0, 1.869],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.458, 0],
                    [0, 0],
                    [0, 1.792],
                    [0, 0],
                    [3.207, 1.146],
                    [0, 0],
                    [0, 0],
                    [2.624, 0.155],
                    [0, 0]
                  ],
                  "o": [
                    [-2.772, 0],
                    [0, 0],
                    [0, 0],
                    [-3.027, 0.943],
                    [0, 0],
                    [0, 1.792],
                    [0, 0],
                    [1.447, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 1.869],
                    [0, 0],
                    [1.381, -0.053],
                    [0, 0],
                    [0, -2.876],
                    [0, 0],
                    [0, 0],
                    [0, -2.519],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-21.458, -25.436],
                    [-27.273, -19.814],
                    [-27.273, -5.591],
                    [-27.748, -5.443],
                    [-33.638, 1.975],
                    [-33.638, 22.159],
                    [-30.077, 25.434],
                    [-29.99, 25.435],
                    [-26.295, 22.159],
                    [-26.295, 21.406],
                    [26.294, 21.406],
                    [26.294, 22.159],
                    [30.001, 25.435],
                    [30.11, 25.433],
                    [33.638, 22.159],
                    [33.638, 1.975],
                    [27.721, -5.443],
                    [27.272, -5.603],
                    [27.272, -19.814],
                    [21.765, -25.424],
                    [21.692, -25.429]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.866, 0],
                    [0, 0],
                    [0, 2.67],
                    [0, 0],
                    [-3.442, 1.324],
                    [0, 0],
                    [-3.55, 0],
                    [-0.059, -0.002],
                    [0, 0],
                    [0, -3.248],
                    [0, 0],
                    [0, -3.312],
                    [0, 0],
                    [1.926, -0.073],
                    [0, 0],
                    [0.395, 2.445],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.949, -0.073],
                    [0, 0],
                    [0, -3.352],
                    [0, 0],
                    [0, -3.454],
                    [0.06, 0],
                    [0, 0],
                    [3.357, 0.198],
                    [0, 0],
                    [3.55, 1.48],
                    [0, 0],
                    [0, 2.67],
                    [0, 0],
                    [-1.89, 0],
                    [0, 0],
                    [-0.395, 2.445]
                  ],
                  "v": [
                    [-30.002, 26.786],
                    [-30.114, 26.784],
                    [-34.989, 22.159],
                    [-34.989, 1.975],
                    [-28.624, -6.568],
                    [-28.624, -19.814],
                    [-21.458, -26.787],
                    [-21.28, -26.784],
                    [21.845, -26.773],
                    [28.623, -19.814],
                    [28.623, -6.542],
                    [34.989, 1.975],
                    [34.989, 22.159],
                    [30.15, 26.783],
                    [30.027, 26.786],
                    [24.99, 22.757],
                    [-24.991, 22.757]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [34.989, 26.786], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 6,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "pillow 2 Outlines",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.227, "y": 1 },
              "o": { "x": 0.646, "y": 0 },
              "t": 0,
              "s": [612.5, 429, 0],
              "to": [0, 11.5, 0],
              "ti": [0, -6.5, 0]
            },
            {
              "i": { "x": 0.319, "y": 1 },
              "o": { "x": 0.732, "y": 0 },
              "t": 11,
              "s": [612.5, 498, 0],
              "to": [0, 6.5, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.31, "y": 1 },
              "o": { "x": 0.708, "y": 0 },
              "t": 24,
              "s": [612.5, 468, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.314, "y": 1 },
              "o": { "x": 0.647, "y": 0 },
              "t": 36,
              "s": [612.5, 498, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.36, "y": 1 },
              "o": { "x": 0.769, "y": 0 },
              "t": 49,
              "s": [612.5, 468, 0],
              "to": [0, 0, 0],
              "ti": [0, 6.5, 0]
            },
            {
              "i": { "x": 0.209, "y": 1 },
              "o": { "x": 0.653, "y": 0 },
              "t": 61,
              "s": [612.5, 498, 0],
              "to": [0, -6.5, 0],
              "ti": [0, 11.5, 0]
            },
            { "t": 77, "s": [612.5, 429, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [7.5, 4, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [1000, 1000, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.042, 0],
                    [0, 0],
                    [0, -1.042],
                    [0, 0],
                    [-1.043, 0],
                    [0, 0],
                    [0, 1.043],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.043, 0],
                    [0, 0],
                    [0, 1.043],
                    [0, 0],
                    [1.042, 0],
                    [0, 0],
                    [0, -1.042]
                  ],
                  "v": [
                    [5.512, -3.599],
                    [-5.512, -3.599],
                    [-7.402, -1.709],
                    [-7.402, 1.707],
                    [-5.512, 3.598],
                    [5.512, 3.598],
                    [7.402, 1.707],
                    [7.402, -1.709]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [7.402, 3.599], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 3.2, "ix": 5 },
          "lc": 1,
          "lj": 1,
          "ml": 4,
          "bm": 0,
          "nm": "Stroke 1",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "pillow Outlines",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.227, "y": 1 },
              "o": { "x": 0.646, "y": 0 },
              "t": 0,
              "s": [389.5, 429, 0],
              "to": [0, 11.5, 0],
              "ti": [0, -6.5, 0]
            },
            {
              "i": { "x": 0.319, "y": 1 },
              "o": { "x": 0.732, "y": 0 },
              "t": 18,
              "s": [389.5, 498, 0],
              "to": [0, 6.5, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.31, "y": 1 },
              "o": { "x": 0.708, "y": 0 },
              "t": 31,
              "s": [389.5, 468, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.314, "y": 1 },
              "o": { "x": 0.647, "y": 0 },
              "t": 43,
              "s": [389.5, 498, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.36, "y": 1 },
              "o": { "x": 0.769, "y": 0 },
              "t": 56,
              "s": [389.5, 468, 0],
              "to": [0, 0, 0],
              "ti": [0, 6.5, 0]
            },
            {
              "i": { "x": 0.209, "y": 1 },
              "o": { "x": 0.653, "y": 0 },
              "t": 68,
              "s": [389.5, 498, 0],
              "to": [0, -6.5, 0],
              "ti": [0, 11.5, 0]
            },
            { "t": 82, "s": [389.5, 429, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [7.5, 4, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [1000, 1000, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1.042, 0],
                    [0, 0],
                    [0, -1.042],
                    [0, 0],
                    [-1.042, 0],
                    [0, 0],
                    [0, 1.043],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1.042, 0],
                    [0, 0],
                    [0, 1.043],
                    [0, 0],
                    [1.042, 0],
                    [0, 0],
                    [0, -1.042]
                  ],
                  "v": [
                    [5.512, -3.599],
                    [-5.512, -3.599],
                    [-7.402, -1.709],
                    [-7.402, 1.707],
                    [-5.512, 3.598],
                    [5.512, 3.598],
                    [7.402, 1.707],
                    [7.402, -1.709]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [7.402, 3.599], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 3.2, "ix": 5 },
          "lc": 1,
          "lj": 1,
          "ml": 4,
          "bm": 0,
          "nm": "Stroke 1",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Shape Layer 1",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [500, 500, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [2, -0.5],
                    [8.5, -2],
                    [0, 0],
                    [0, 0],
                    [-46, 0],
                    [-1.5, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-2, 0.5],
                    [-8.5, 2],
                    [0, 0],
                    [0, 0],
                    [46, 0],
                    [1.5, 0],
                    [0, 0]
                  ],
                  "v": [
                    [155.5, -165],
                    [-17.5, -160.5],
                    [-238.5, -128],
                    [-202.75, -39.625],
                    [0.5, -46],
                    [207, -39.5],
                    [220.5, -112.5]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0.156859992532, 0.333312988281, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156859992532, 0.333312988281, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
